import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary text-white pt-20 pb-10 px-4" data-id="element-56">
      <div className="max-w-7xl mx-auto" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-58">
          {/* Brand Col */}
          <div data-id="element-59">
            <div className="mb-6" data-id="element-60">
              <div className="inline-block bg-white/5 p-2 rounded-full backdrop-blur-sm border border-white/10" data-id="element-61">
                <img src="https://cdn.magicpatterns.com/uploads/bw7AM2ZxN5rndR2BD9QGFb/Gemini_Generated_Image_e872g4e872g4e872-removebg-preview.png" alt="Ambient Solutions LLC — A Tailored Path to Optimal Health" className="h-24 w-auto brightness-110 contrast-110" data-id="element-62" />
              </div>
            </div>
            <p className="text-white/70 mb-6 text-sm leading-relaxed" data-id="element-63">
              Ambient Solutions LLC — A Tailored Path to Optimal Health. We help
              families hire, train, and certify their own loved ones as
              professional caregivers, backed by skilled nursing oversight.
            </p>
            <div className="flex items-center gap-4" data-id="element-64">
              <a href="#" className="text-white/70 hover:text-accent transition-colors" aria-label="Facebook" data-id="element-65">
                <FacebookIcon className="w-5 h-5" data-id="element-66" />
              </a>
              <a href="#" className="text-white/70 hover:text-accent transition-colors" aria-label="Twitter" data-id="element-67">
                <TwitterIcon className="w-5 h-5" data-id="element-68" />
              </a>
              <a href="#" className="text-white/70 hover:text-accent transition-colors" aria-label="Instagram" data-id="element-69">
                <InstagramIcon className="w-5 h-5" data-id="element-70" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-71">
            <h3 className="font-heading font-bold text-lg mb-6 text-accent" data-id="element-72">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-73">
              <li data-id="element-74">
                <Link to="/" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-75">
                  Home
                </Link>
              </li>
              <li data-id="element-76">
                <Link to="/about" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-77">
                  About Us
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/services" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-79">
                  Services
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/how-it-works" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-81">
                  How It Works
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/contact" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-83">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-84">
            <h3 className="font-heading font-bold text-lg mb-6 text-accent" data-id="element-85">
              Our Services
            </h3>
            <ul className="space-y-4" data-id="element-86">
              <li className="text-white/70 text-sm" data-id="element-87">Skilled Nursing</li>
              <li className="text-white/70 text-sm" data-id="element-88">Personal Care</li>
              <li className="text-white/70 text-sm" data-id="element-89">Companion Care</li>
              <li className="text-white/70 text-sm" data-id="element-90">Alzheimer's/Dementia</li>
              <li className="text-white/70 text-sm" data-id="element-91">Respite Care</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-92">
            <h3 className="font-heading font-bold text-lg mb-6 text-accent" data-id="element-93">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-94">
              <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-95">
                <MapPinIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-96" />
                <span data-id="element-97">
                  10632 Little Patuxent Parkway
                  <br data-id="element-98" />
                  Columbia, MD 21044
                </span>
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm" data-id="element-99">
                <PhoneIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-100" />
                <a href="tel:+18666528987" className="hover:text-accent transition-colors" data-id="element-101">
                  (866) 652-8987
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm" data-id="element-102">
                <MailIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-103" />
                <a href="mailto:info@ambienthomecare.com" className="hover:text-accent transition-colors" data-id="element-104">
                  info@ambienthomecare.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-105">
                <ClockIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-106" />
                <span data-id="element-107">
                  Mon - Fri: 8:00 AM - 6:00 PM
                  <br data-id="element-108" />
                  Sat - Sun: Closed
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-109">
          <p className="text-white/50 text-sm" data-id="element-110">
            &copy; 2026 Ambient Solutions LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-white/50" data-id="element-111">
            <a href="#" className="hover:text-white transition-colors" data-id="element-112">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-113">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}